import React, {useEffect} from "react";
import styled from "@emotion/styled";
// import imageAsset from "assets/images/tutorialSecondStep.png";
import imageAsset from "assets/images/tutorialPlayers.jpg";
import {useTranslation} from "react-i18next";
import {AdobeAnalyticService} from "modules/utils/Services/AdobeAnalyticService";
import {AdobeTrackStateActions} from "modules/enums";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;

	img {
		max-height: 280px;
		width: 100%;
		height: auto;
		max-width: 240px;
		margin-bottom: 36px;
		-webkit-border-radius: 22px;
		-moz-border-radius: 22px;
		border-radius: 22px;
		padding: 6px;
		box-sizing: initial;
		border: 1px solid #ffffff;
	}

	p {
		font-style: normal;
		font-weight: 400;
		font-size: 18px;
		line-height: 24px;
		text-align: center;
		color: ${({theme}) => theme.colors.text.white};
		margin-bottom: 24px;

		&.title {
			font-weight: 600;
			font-size: 20px;
			line-height: 24px;
			margin-bottom: 12px;
		}
	}
`;

export const FirstTutorialStep: React.FC = () => {
	const {t} = useTranslation();

	useEffect(() => {
		AdobeAnalyticService.TrackState(
			{
				"page.name": AdobeTrackStateActions.HowToPlay,
				"page.viewType": "",
				"page.viewSubType": "",
			},
			true
		);
	}, []);

	return (
		<Wrapper>
			<img src={imageAsset} alt="step-2-guess" />
			<p className="title">{t("modal.tutorial.end_title")}</p>
			<p>{t("modal.tutorial.end_text")}</p>
		</Wrapper>
	);
};
